import { render, staticRenderFns } from "./flowers.vue?vue&type=template&id=1009b09a&"
import script from "./flowers.vue?vue&type=script&lang=js&"
export * from "./flowers.vue?vue&type=script&lang=js&"
import style0 from "./flowers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports